var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeng3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 285,
    viewBox: "0 0 352 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 4,
    fill: "url(#paint0_radial_1833_3422)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 43,
    r: 4,
    fill: "url(#paint1_radial_1833_3422)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 61,
    r: 4,
    fill: "url(#paint2_radial_1833_3422)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 79,
    r: 4,
    fill: "url(#paint3_radial_1833_3422)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter4_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 97,
    r: 4,
    fill: "url(#paint4_radial_1833_3422)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 115,
    r: 4,
    fill: "url(#paint5_radial_1833_3422)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter6_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 133,
    r: 4,
    fill: "url(#paint6_radial_1833_3422)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 151,
    r: 4,
    fill: "url(#paint7_radial_1833_3422)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter8_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 169,
    r: 4,
    fill: "url(#paint8_radial_1833_3422)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 187,
    r: 4,
    fill: "url(#paint9_radial_1833_3422)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter10_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 205,
    r: 4,
    fill: "url(#paint10_radial_1833_3422)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 223,
    r: 4,
    fill: "url(#paint11_radial_1833_3422)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter12_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 241,
    r: 4,
    fill: "url(#paint12_radial_1833_3422)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 258,
    r: 4,
    fill: "url(#paint13_radial_1833_3422)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter14_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 261,
    r: 4,
    fill: "url(#paint14_radial_1833_3422)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 261,
    r: 4,
    fill: "url(#paint15_radial_1833_3422)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter16_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 261,
    r: 4,
    fill: "url(#paint16_radial_1833_3422)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 261,
    r: 4,
    fill: "url(#paint17_radial_1833_3422)"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter18_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 261,
    r: 4,
    fill: "url(#paint18_radial_1833_3422)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 132,
    cy: 261,
    r: 4,
    fill: "url(#paint19_radial_1833_3422)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter20_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 261,
    r: 4,
    fill: "url(#paint20_radial_1833_3422)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 261,
    r: 4,
    fill: "url(#paint21_radial_1833_3422)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter22_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 261,
    r: 4,
    fill: "url(#paint22_radial_1833_3422)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 204,
    cy: 261,
    r: 4,
    fill: "url(#paint23_radial_1833_3422)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter24_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 261,
    r: 4,
    fill: "url(#paint24_radial_1833_3422)"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 261,
    r: 4,
    fill: "url(#paint25_radial_1833_3422)"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter26_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 261,
    r: 4,
    fill: "url(#paint26_radial_1833_3422)"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter27_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 276,
    cy: 261,
    r: 4,
    fill: "url(#paint27_radial_1833_3422)"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter28_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 261,
    r: 4,
    fill: "url(#paint28_radial_1833_3422)"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter29_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 261,
    r: 4,
    fill: "url(#paint29_radial_1833_3422)"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter30_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 257,
    r: 4,
    fill: "url(#paint30_radial_1833_3422)"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter31_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 241,
    r: 4,
    fill: "url(#paint31_radial_1833_3422)"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter32_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 223,
    r: 4,
    fill: "url(#paint32_radial_1833_3422)"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter33_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 205,
    r: 4,
    fill: "url(#paint33_radial_1833_3422)"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter34_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 187,
    r: 4,
    fill: "url(#paint34_radial_1833_3422)"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter35_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 169,
    r: 4,
    fill: "url(#paint35_radial_1833_3422)"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter36_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 151,
    r: 4,
    fill: "url(#paint36_radial_1833_3422)"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter37_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 133,
    r: 4,
    fill: "url(#paint37_radial_1833_3422)"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter38_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 115,
    r: 4,
    fill: "url(#paint38_radial_1833_3422)"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter39_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 97,
    r: 4,
    fill: "url(#paint39_radial_1833_3422)"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter40_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 79,
    r: 4,
    fill: "url(#paint40_radial_1833_3422)"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter41_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 61,
    r: 4,
    fill: "url(#paint41_radial_1833_3422)"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter42_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 42,
    r: 4,
    fill: "url(#paint42_radial_1833_3422)"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter43_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 328,
    cy: 25,
    r: 4,
    fill: "url(#paint43_radial_1833_3422)"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter44_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 4,
    fill: "url(#paint44_radial_1833_3422)"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter45_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 24,
    r: 4,
    fill: "url(#paint45_radial_1833_3422)"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter46_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 24,
    r: 4,
    fill: "url(#paint46_radial_1833_3422)"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter47_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 24,
    r: 4,
    fill: "url(#paint47_radial_1833_3422)"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter48_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 24,
    r: 4,
    fill: "url(#paint48_radial_1833_3422)"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter49_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 24,
    r: 4,
    fill: "url(#paint49_radial_1833_3422)"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter50_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 24,
    r: 4,
    fill: "url(#paint50_radial_1833_3422)"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter51_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 24,
    r: 4,
    fill: "url(#paint51_radial_1833_3422)"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter52_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 24,
    r: 4,
    fill: "url(#paint52_radial_1833_3422)"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter53_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 24,
    r: 4,
    fill: "url(#paint53_radial_1833_3422)"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter54_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 24,
    r: 4,
    fill: "url(#paint54_radial_1833_3422)"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter55_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 242,
    cy: 24,
    r: 4,
    fill: "url(#paint55_radial_1833_3422)"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter56_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 24,
    r: 4,
    fill: "url(#paint56_radial_1833_3422)"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter57_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 278,
    cy: 24,
    r: 4,
    fill: "url(#paint57_radial_1833_3422)"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter58_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 295,
    cy: 24,
    r: 4,
    fill: "url(#paint58_radial_1833_3422)"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter59_d_1833_3422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 312,
    cy: 24,
    r: 4,
    fill: "url(#paint59_radial_1833_3422)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1833_3422",
    x: 3,
    y: 3,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1833_3422",
    x: 10,
    y: 29,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1833_3422",
    x: 0,
    y: 37,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1833_3422",
    x: 10,
    y: 65,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1833_3422",
    x: 0,
    y: 73,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1833_3422",
    x: 10,
    y: 101,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1833_3422",
    x: 0,
    y: 109,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_1833_3422",
    x: 10,
    y: 137,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_1833_3422",
    x: 0,
    y: 145,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_1833_3422",
    x: 10,
    y: 173,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d_1833_3422",
    x: 0,
    y: 181,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d_1833_3422",
    x: 10,
    y: 209,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_1833_3422",
    x: 0,
    y: 217,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_1833_3422",
    x: 12,
    y: 244,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_1833_3422",
    x: 18,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d_1833_3422",
    x: 46,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d_1833_3422",
    x: 54,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d_1833_3422",
    x: 82,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d_1833_3422",
    x: 90,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d_1833_3422",
    x: 118,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d_1833_3422",
    x: 126,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d_1833_3422",
    x: 154,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d_1833_3422",
    x: 162,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d_1833_3422",
    x: 190,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d_1833_3422",
    x: 198,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d_1833_3422",
    x: 226,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter26_d_1833_3422",
    x: 234,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter27_d_1833_3422",
    x: 262,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter28_d_1833_3422",
    x: 270,
    y: 237,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter29_d_1833_3422",
    x: 298,
    y: 247,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter30_d_1833_3422",
    x: 304,
    y: 233,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter31_d_1833_3422",
    x: 314,
    y: 227,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter32_d_1833_3422",
    x: 304,
    y: 199,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter33_d_1833_3422",
    x: 314,
    y: 191,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter34_d_1833_3422",
    x: 304,
    y: 163,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter35_d_1833_3422",
    x: 314,
    y: 155,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter36_d_1833_3422",
    x: 304,
    y: 127,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter37_d_1833_3422",
    x: 314,
    y: 119,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter38_d_1833_3422",
    x: 304,
    y: 91,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter39_d_1833_3422",
    x: 314,
    y: 83,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter40_d_1833_3422",
    x: 304,
    y: 55,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter41_d_1833_3422",
    x: 314,
    y: 47,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter42_d_1833_3422",
    x: 304,
    y: 18,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter43_d_1833_3422",
    x: 314,
    y: 11,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter44_d_1833_3422",
    x: 30,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter45_d_1833_3422",
    x: 38,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter46_d_1833_3422",
    x: 66,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter47_d_1833_3422",
    x: 74,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter48_d_1833_3422",
    x: 102,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter49_d_1833_3422",
    x: 110,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter50_d_1833_3422",
    x: 138,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter51_d_1833_3422",
    x: 146,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter52_d_1833_3422",
    x: 174,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter53_d_1833_3422",
    x: 182,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter54_d_1833_3422",
    x: 210,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter55_d_1833_3422",
    x: 218,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter56_d_1833_3422",
    x: 246,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter57_d_1833_3422",
    x: 254,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter58_d_1833_3422",
    x: 281,
    y: 10,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter59_d_1833_3422",
    x: 288,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.8 0 0 0 0 0.0196078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1833_3422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1833_3422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.6667 25.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 41.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 59.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 77.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 95.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 113.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 131.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 149.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 167.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 185.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 203.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 221.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6667 239.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6667 256.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.6667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.6667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(220.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(238.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(274.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(292.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.667 259.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 255.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 239.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 221.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 203.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 185.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 167.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 149.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 131.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 113.933) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 95.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 77.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 59.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 40.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(326.667 23.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(96.6667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(204.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(222.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(240.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(258.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(276.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(293.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#FDCC05"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1833_3422",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(310.667 22.9333) rotate(29.5388) scale(9.19517)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeng3);
export default __webpack_public_path__ + "static/media/deng3.740174a6672d5c7a5be7c15f99f34ddd.svg";
export { ForwardRef as ReactComponent };